import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import SurveyIframe, { SurveyAction } from './SurveyIframe';

const TurnOffAutoRenewDialog = (
  {
    showDialog,
    handleCloseDialog,
    toggleAutoRenew,
  }: {
    showDialog: boolean,
    handleCloseDialog: () => void,
    toggleAutoRenew: () => void,
  },
) => {
  const handleSurveyClose = (action: SurveyAction) => {
    if (action === SurveyAction.FINISH) {
      toggleAutoRenew();
    } else if (action === SurveyAction.CANCEL) {
      handleCloseDialog();
    }
  };

  return (
    <Dialog
      open={showDialog}
      id="cancel-order-dialog"
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          paddingX: 2,
          borderRadius: 1.5,
          height: 700,
        },
      }}
    >
      <DialogContent
        id="turn-off-auto-renewal-survey-dialog-content"
        key="turn-off-auto-renewal-survey-dialog-content"
        sx={theme => ({
          padding: 0,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          paddingBottom: theme.spacing(2),
        })}
      >
        <SurveyIframe
          handleSurveyClose={handleSurveyClose}
        />
      </DialogContent>
    </Dialog>
  );
};

export default TurnOffAutoRenewDialog;
